











































import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
    name: 'Home',
    created() {
        this.$store.state.routeLoaded = true;
    }
})
